import { defaultTelosProviderConfiguration } from 'src/features/on-chain/calculation-manager/providers/dexes/telos/default-constants';

export const SUSHI_SWAP_TELOS_CONTRACT_ADDRESS = '0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506';

export const SUSHI_SWAP_TELOS_PROVIDER_CONFIGURATION = defaultTelosProviderConfiguration;
